import React from 'react';
import { Button } from './ui/Button';
import { ArrowDownIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-24 pb-16 px-4 md:pt-32 md:pb-20 relative overflow-hidden" data-id="element-76">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#D4850A]/5 rounded-full blur-[100px] pointer-events-none" data-id="element-77"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-78">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6 text-[#3D2B1F]" data-id="element-79">
          <span className="text-[#D4850A]" data-id="element-80">🔥 Más de 50 Recetas</span> de
          Budines Caseros Irresistibles
        </h1>

        <p className="text-xl md:text-2xl text-[#6B5344] mb-6 font-medium" data-id="element-81">
          Aprendé a preparar budines perfectos, húmedos y deliciosos con recetas
          simples que cualquiera puede hacer en casa.
        </p>

        <p className="text-lg text-[#9B8578] mb-10 max-w-3xl mx-auto" data-id="element-82">
          Sorprendé a tu familia, invitados o clientes con budines que parecen
          de pastelería profesional, usando ingredientes simples que ya tenés en
          tu cocina.
        </p>

        <div className="relative w-full max-w-4xl mx-auto h-[400px] md:h-[600px] cursor-pointer group mb-12" onClick={() => document.getElementById('compra')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-83">
          {/* Background glow */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-[#D4850A]/10 rounded-full blur-[100px] pointer-events-none" data-id="element-84"></div>

          {/* Main Book */}
          <img src="https://cdn.magicpatterns.com/uploads/njMAY3XguUNyW1FQwxsdek/0_cover_1.png" alt="Libro Principal" className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-1/2 md:w-[40%] z-30 drop-shadow-2xl transform transition-transform duration-500 group-hover:scale-105" data-id="element-85" />

          {/* Bonus 1 - Back Left */}
          <img src="https://cdn.magicpatterns.com/uploads/fWrSuNCw9LpS5kCptS5t7g/bono_1.png" alt="Bono 1" className="absolute top-[40%] left-[15%] md:left-[20%] -translate-y-1/2 w-[35%] md:w-[25%] z-20 drop-shadow-xl -rotate-12 transform transition-transform duration-500 group-hover:-translate-x-4 group-hover:-rotate-6" data-id="element-86" />

          {/* Bonus 2 - Back Right */}
          <img src="https://cdn.magicpatterns.com/uploads/fNMRDkw1z7jg2D6B7MAj2p/bono_2.png" alt="Bono 2" className="absolute top-[40%] right-[15%] md:right-[20%] -translate-y-1/2 w-[35%] md:w-[25%] z-20 drop-shadow-xl rotate-12 transform transition-transform duration-500 group-hover:translate-x-4 group-hover:rotate-6" data-id="element-87" />

          {/* Bonus 3 - Front Left */}
          <img src="https://cdn.magicpatterns.com/uploads/6J65ZVSEbjBSnvsYzg3hwK/bono_3.png" alt="Bono 3" className="absolute bottom-[10%] left-[5%] md:left-[10%] w-[40%] md:w-[30%] z-40 drop-shadow-2xl -rotate-6 transform transition-transform duration-500 group-hover:-translate-x-6 group-hover:-rotate-3" data-id="element-88" />

          {/* Bonus 4 - Front Right */}
          <img src="https://cdn.magicpatterns.com/uploads/9n84b1w2G9XGH8gVrcXbGY/bono_4.png" alt="Bono 4" className="absolute bottom-[10%] right-[5%] md:right-[10%] w-[40%] md:w-[30%] z-40 drop-shadow-2xl rotate-6 transform transition-transform duration-500 group-hover:translate-x-6 group-hover:rotate-3" data-id="element-89" />
        </div>

        <Button href="#compra" size="xl" className="group flex flex-col items-center gap-2" data-id="element-90">
          <span data-id="element-91">¡SÍ! QUIERO EL LIBRO AHORA</span>
          <span className="text-sm font-normal text-white/70" data-id="element-92">
            Click aquí para ver la oferta especial
          </span>
        </Button>

        <div className="mt-6 animate-bounce" data-id="element-93">
          <ArrowDownIcon className="w-6 h-6 text-[#9B8578] mx-auto" data-id="element-94" />
        </div>
      </div>
    </section>;
}